import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { PapiGallection } from '@wix/da-papi-types';
import { NotificationQueueItem, Notification } from '@wix/da-shared-react/pkg/Notifications';
import { NotificationDuration } from '@wix/da-shared-react/pkg/Notifications/Notification';
import SystemNotification from '@wix/da-shared-react/pkg/SystemNotification';
import GallectionCoverDumbo from '@wix/da-shared-react/pkg/GallectionCoverDumbo';
import { undoAddBookmark } from '@wix/da-submit-shared/pkg/redux/actions';

import s from './BookmarkAddedNotification.scss';

export interface Props extends Omit<NotificationQueueItem, 'type'> {
  gallection: PapiGallection;
}

const BookmarkAddedNotification: FC<Props> = ({ id, queueName, gallection }) => {
  const { t } = useTranslation();
  const onUndo = useAction(undoAddBookmark);
  const onUndoClick = useCallback(() => onUndo(gallection), [onUndo, gallection]);

  const customIcon = <GallectionCoverDumbo gallection={gallection} width={48} height={48} />;

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        className: s['notification-card'],
        textClassName: s['notification-card-text'],
        iconClassName: s['notification-card-icon'],
        customIcon,
        multiLine: true,
        limitTextWidth: false,
        duration: NotificationDuration.S,
        actions: [
          {
            label: t('common.undo'),
            onClick: onUndoClick,
            closeOnClick: true,
          },
        ],
      }}
    >
      {t('studio.notifications.bookmarks.add.text', {
        title: gallection.name,
      })}
    </Notification>
  );
};
BookmarkAddedNotification.displayName = 'BookmarkAddedNotification';

export default BookmarkAddedNotification;
